// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"dd7106a5","947":"e49da5b6"}[chunkId] + ".chunk.js";
};